<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 

    <el-main style="overflow-x: hidden;">
      <el-form ref="form" label-width="150px" >
          <el-row>
            <el-col :span="14">
              <el-form-item :label="$t('field.installedTime')">
                <el-col :span="12">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="10">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="Software">
                <el-select v-model="software" style="width:100%" :placeholder="$t('msg.pleaseSelect')" :clearable="true">
                  <el-option v-for="item in softwareOpts"  :key="item"  :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>        
          </el-row>    
          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('field.acceptanceStatus')">
                <el-select v-model="acceptanceStatus" style="width:100%" :placeholder="$t('msg.pleaseSelect')" :clearable="true">
                  <el-option v-for="item in acceptanceStatusOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col> 
            <el-col :span="12" > 
              <CustomerSearch v-model="custSapCode"  @sync-select-customer="syncSelectCustomer" v-if="!isCustomer" />           
          </el-col>      
          </el-row>  
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
            </el-col>             
          </el-row>
        </el-form>
       
          <Table ref="resultTable" :tableData="tableData" :checkAction="checkAction"  :linkAction="linkAction"  @reload-data-by-sort="reloadDataBySort"/> 
    
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'
import Table from '../components/FuzzySearchTableWithRemoteSort'
import { apiFindInstalledList, apiInstallAcceptTime} from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";
import CustomerSearch from "../components/CustomerSearch";

export default {
  name: 'installedMachineList',
  data() {   
    return {     
      content: this.$i18n.t('menu.productList'),
      sortColumn:'',
      sortType:'',
      sdate: '',
      edate: '',
      software: '',
      softwareOpts:['HumanDROC', 'VetDROC'],
      acceptanceStatus: '',
      acceptanceStatusOpts: [{label:'Not Acceptance',value:'N'},{label:'Acceptance', value:'Y'}],  
      tableData: {
        sel: null,
        columns: [
          { field:'custSapCode', title: this.$i18n.t('field.customerNo'), width: 350},
          { field:'serialno', title: 'Serial No.', link:true, width: 350 },
          { field:'institutionName', title: 'Institution Name', width: 350},
          { field:'installedTime', title: 'Installation Date', width: 160},
          { field:'sw', title: 'Software Model', width: 170},
          { field:'acceptTime', title:  this.$i18n.t('field.acceptanceStatus'), checkbox : true, align:'center', tooltip:'Acceptance' , width: 170 }
        ],  
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'shippingDataTable',
        exportName: this.$i18n.t('menu.shippingData')
      },
      isCustomer:false,
      custSapCode:''
    };
  }, 
  components: {
    Breadcrumb,
    Table,
    CustomerSearch 
  },
  mounted() {

  },
  created(){
    this.isCustomer = this.$store.state.auth.user.username.indexOf('@')>-1 ? true : false;    
  },
  methods: {
    readData(){
      this.loading = true;
      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = CommonUtil.dateFormatDate(this.sdate);
      }
      if(this.edate != null && this.edate != ''){        
        edate = CommonUtil.dateFormatDate(this.edate);
      }
      apiFindInstalledList({ headers: authHeader(), custSapCode:this.custSapCode, sw: this.software, isAcceptance:this.acceptanceStatus, 
          sdate:sdate, edate: edate, sortColumn: this.sortColumn, sortType:this.sortType }).then((response) => {        
         response.data.forEach((item, index) => {
          if(item.installedTime != null && item.installedTime != '' && item.installedTime.length > 11){
            item.installedTime = CommonUtil.dateFormatDate(new Date(item.installedTime));            
          }  
          if(item.acceptTime != null && item.acceptTime != ''){
              item.acceptTime = CommonUtil.dateFormat(new Date(item.acceptTime));
          }       
        }); 

        this.tableData.data = response.data;
        this.tableData.originalTableData =  this.tableData.data;  
        this.tableData.currentPage=1;
        this.loading = false;
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    },
    syncSelectCustomer(custNo){            
      this.custSapCode = custNo;
    },
    search(){
      if(this.isCustomer){
        if((this.software == null || this.software == '') && (this.sdate == null || this.sdate == '')  && (this.edate == null || this.edate == '') && (this.acceptanceStatus == null || this.acceptanceStatus == '')  ){
          return this.$message.warning({message: this.$i18n.t('msg.selectOneAtleast'), duration: 800});
        }   
      }
         
      this.readData();
      
    },
    checkAction(row, index){      
      const msg = this.$i18n.t('msg.sendAcceptanceTime').replace('{serialNo}', row.serialno);      
      this.$confirm(msg, {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.loading = true;        
        apiInstallAcceptTime({ headers: authHeader(), id:row.id }).then((response) => {     
    
          if(response.status == 200){
            this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});     
            this.readData();
          }else{
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
          }
          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          console.log(err);
        });
        done();
      }).catch(_ => {});   
      
    },
    linkAction(row, index){  
      debugger
      if(this.isCustomer){
        this.$router.push("/createinstalledMachine/" + row.id);
      }else{
        const { href } = this.$router.resolve("/createinstalledMachine/" + row.id);
        window.open(href, '_blank');
      }
      
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      debugger
      this.readData()
    }     
    
  }
};
</script>
